var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"iconImg",style:(_vm.style),attrs:{"src":_vm.iconUrl,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }